import type { SlideProps } from "@/engine/app/offsite-config";

const AUSSAGEN = [
  {
    title: "Was sich ändert",
    text: "Die Routine wandert in die Automatisierung: Abtippen, Zusammensuchen, Standardantworten. Das wird weniger — und das ist gewollt.",
  },
  {
    title: "Was bleibt",
    text: "Fachentscheidung, Kundenkontakt, Verantwortung. Die KI bereitet vor — unterschreiben tut sie nichts.",
  },
  {
    title: "Was ihr mitbestimmt",
    text: "Ihr habt heute gezeigt, was gebaut werden soll. Welche Vorgänge als Nächstes drankommen, entscheidet sich mit euch — nicht über euch.",
  },
];

export function Slide17bWasHeisstDas(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Ehrlich gesagt</div>
        <h1 className="deck-title rise rise-2">
          Was heißt das <br />
          <span className="accent">für euch?</span>
        </h1>
      </header>

      <div className="deck-cols2" style={{ gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }}>
        {AUSSAGEN.map((a, i) => (
          <div key={a.title} className={`col-card rise rise-${i + 4}`}>
            <div className="col-eyebrow">0{i + 1}</div>
            <h4>{a.title}</h4>
            <p>{a.text}</p>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>Und genau darüber reden wir jetzt.</span>
      </footer>
    </div>
  );
}
